import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, NavItem, Collapse } from 'reactstrap';
import logo from '../assets/images/logo.png';
import logoWhite from '../assets/images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/sidebar.css';

const Sidebar = ({ company }) => {
    const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <= 768);
    const [isDarkTheme, setIsDarkTheme] = useState(true); // Default to dark theme

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsCollapsed(true);
            } else {
                setIsCollapsed(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const isDark = document.body.classList.contains('dark-theme');
        setIsDarkTheme(isDark);
        const observer = new MutationObserver((muts) => {
          muts.forEach((m) => {
            if (m.type === 'attributes' && m.attributeName === 'class') {
              setIsDarkTheme(document.body.classList.contains('dark-theme'));
            }
          });
        });
        observer.observe(document.body, { attributes: true });
        return () => observer.disconnect();
      }, []);


    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const toggleTheme = () => {
        setIsDarkTheme(!isDarkTheme);
    };

    return (
        <>
            <div className={`modern-sidebar ${isCollapsed ? 'collapsed' : ''} ${isDarkTheme ? 'dark' : 'light'}`}>
                {/* Header Section */}
                <div className="sidebar-header">
                    <div className="logo-section">
                        <a href="/profile/home">
                            <img src={isDarkTheme ? logoWhite : logo} alt="Logo" className="logo" />
                        </a>
                    </div>
                </div>

                {/* Theme Toggle */}
                {/* <div className="theme-toggle-section">
                    <button className="theme-toggle-btn" onClick={toggleTheme}>
                        <FontAwesomeIcon 
                            icon={isDarkTheme ? faSun : faMoon} 
                            className="theme-icon"
                        />
                        {!isCollapsed && (
                            <span className="theme-text">
                               
                            </span>
                        )}
                    </button>
                </div> */}

                {/* Navigation Menu */}
                <Nav vertical className="v">
                    {/* Main Navigation Items */}
                    <NavItem>
                        <NavLink to="/profile/home" className="nav-link-modern">
                            <div className="nav-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <path d="M10.5 25.6666V13.9999H17.5V25.6666M3.5 10.4999L14 2.33325L24.5 10.4999V23.3333C24.5 23.9521 24.2542 24.5456 23.8166 24.9832C23.379 25.4208 22.7855 25.6666 22.1667 25.6666H5.83333C5.21449 25.6666 4.621 25.4208 4.18342 24.9832C3.74583 24.5456 3.5 23.9521 3.5 23.3333V10.4999Z" stroke="url(#paint0_linear_599_13267)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <defs>
                                        <linearGradient id="paint0_linear_599_13267" x1="6.15954" y1="2.33328" x2="22.4007" y2="2.52041" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#3B6255" />
                                            <stop offset="1" stop-color="#6DB39B" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            {!isCollapsed && <span className="nav-text">لوحة التحكم الرئيسية</span>}
                        </NavLink>
                    </NavItem>

                    <NavItem>
                        <NavLink to="/profile/offset" className="nav-link-modern">
                            <div className="nav-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <path d="M14 9.33333V18.6667M9.33333 14H18.6667M5.83333 3.5H22.1667C23.4553 3.5 24.5 4.54467 24.5 5.83333V22.1667C24.5 23.4553 23.4553 24.5 22.1667 24.5H5.83333C4.54467 24.5 3.5 23.4553 3.5 22.1667V5.83333C3.5 4.54467 4.54467 3.5 5.83333 3.5Z" stroke="url(#paint0_linear_599_13287)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <defs>
                                        <linearGradient id="paint0_linear_599_13287" x1="14" y1="3.5" x2="14" y2="24.5" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#D2C49E" />
                                            <stop offset="1" stop-color="#5D5130" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            {!isCollapsed && <span className="nav-text">قائمة الخدمات</span>}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/profile/my-surveys" className="nav-link-modern">
                            <div className="nav-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <path d="M24.5001 9.33333V24.5H3.50008V9.33333M11.6667 14H16.3334M1.16675 3.5H26.8334V9.33333H1.16675V3.5Z" stroke="url(#paint0_linear_599_13307)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <defs>
                                        <linearGradient id="paint0_linear_599_13307" x1="14.0001" y1="3.5" x2="14.0001" y2="24.5" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#D2C49E" />
                                            <stop offset="1" stop-color="#5D5130" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            {!isCollapsed && <span className="nav-text">قائمة الطلبات</span>}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/profile/choose-portfolio" className="nav-link-modern">
                            <div className="nav-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <path d="M0.925781 28H22.2487V23.516H24.0076V17.8629H22.2487V13.1377L23.6946 11.6918L27.074 8.31239L23.6946 4.93295L22.1411 3.3795L18.7617 0L15.3822 3.37944L15.3822 3.3795L8.90062 9.86108H0.925781V28ZM24.7545 8.31239L23.8004 9.26647C23.5282 8.66158 23.5282 7.9632 23.8004 7.35831L24.7545 8.31239ZM22.5956 6.15344C21.7447 7.46082 21.7447 9.16396 22.5956 10.4713L19.6881 13.3788H18.545C18.5743 13.3515 18.6036 13.3244 18.6321 13.2959C19.2803 12.6477 19.6374 11.7857 19.6374 10.8689C19.6374 9.95211 19.2804 9.09021 18.6321 8.44191C17.9838 7.7936 17.1219 7.4366 16.2051 7.4366C15.2883 7.4366 14.4264 7.7936 13.7781 8.44191C13.1298 9.09021 12.7728 9.95211 12.7728 10.8689C12.7728 11.7857 13.1298 12.6476 13.7781 13.2959C13.8065 13.3243 13.8359 13.3515 13.8651 13.3788H10.454C10.4436 12.6315 10.2213 11.8967 9.81365 11.2675L16.6023 4.47884C17.2391 4.895 17.9831 5.119 18.7616 5.119C19.5402 5.119 20.2841 4.89506 20.921 4.4789L22.5956 6.15344ZM14.413 10.869C14.413 10.3903 14.5994 9.94025 14.9379 9.60172C15.2764 9.26319 15.7264 9.07681 16.2051 9.07681C16.6838 9.07681 17.1338 9.26319 17.4724 9.60172C17.8109 9.94025 17.9973 10.3903 17.9973 10.869C17.9973 11.3477 17.8109 11.7977 17.4724 12.1362C17.1338 12.4747 16.6838 12.6611 16.2051 12.6611C15.7264 12.6611 15.2764 12.4747 14.9379 12.1362C14.5994 11.7977 14.413 11.3477 14.413 10.869ZM7.70238 13.3788L8.61174 12.4695C8.74175 12.7548 8.81124 13.0635 8.81648 13.3788H7.70238ZM19.7166 3.27447C19.4204 3.40836 19.0965 3.47883 18.7617 3.47883C18.4269 3.47883 18.1029 3.40836 17.8067 3.27447L18.7617 2.31951L19.7166 3.27447ZM2.56594 11.5012H7.26046L5.38292 13.3788H2.56594V11.5012ZM20.6085 26.3598H2.56594V15.019H20.6085V17.8629H17.8314C16.6683 17.8629 15.7219 18.8092 15.7219 19.9723V21.4065C15.7219 22.5696 16.6683 23.516 17.8314 23.516H20.6085V26.3598H20.6085ZM22.3674 21.8758H17.8314C17.5726 21.8758 17.362 21.6653 17.362 21.4065V19.9723C17.362 19.7136 17.5726 19.503 17.8314 19.503H22.3674V21.8758Z" fill="url(#paint0_linear_599_13480)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_599_13480" x1="13.9999" y1="0" x2="13.9999" y2="28" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#D2C49E" />
                                            <stop offset="1" stop-color="#5D5130" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            {!isCollapsed && <span className="nav-text">محفظتي</span>}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/profile/workflows" className="nav-link-modern">
                            <div className="nav-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M1.5 19V12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12V19M22.5 20.1667C22.5 20.7855 22.2542 21.379 21.8166 21.8166C21.379 22.2542 20.7855 22.5 20.1667 22.5H19C18.3812 22.5 17.7877 22.2542 17.3501 21.8166C16.9125 21.379 16.6667 20.7855 16.6667 20.1667V16.6667C16.6667 16.0478 16.9125 15.4543 17.3501 15.0168C17.7877 14.5792 18.3812 14.3333 19 14.3333H22.5V20.1667ZM1.5 20.1667C1.5 20.7855 1.74583 21.379 2.18342 21.8166C2.621 22.2542 3.21449 22.5 3.83333 22.5H5C5.61884 22.5 6.21233 22.2542 6.64992 21.8166C7.0875 21.379 7.33333 20.7855 7.33333 20.1667V16.6667C7.33333 16.0478 7.0875 15.4543 6.64992 15.0168C6.21233 14.5792 5.61884 14.3333 5 14.3333H1.5V20.1667Z" stroke="url(#paint0_linear_674_53)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <defs>
                                        <linearGradient id="paint0_linear_674_53" x1="12" y1="1.5" x2="12" y2="22.5" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#D2C49E" />
                                            <stop offset="1" stop-color="#5D5130" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            {!isCollapsed && <span className="nav-text">الدعم الفني</span>}
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>

            {/* Sidebar Toggle Button */}
            {/* <button className={`sidebar-toggle-btn ${isDarkTheme ? 'dark' : 'light'}`} onClick={toggleSidebar}>
                <i className={`bi ${isCollapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
            </button> */}
        </>
    );
};

export default Sidebar;